import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {LangChange} from '../../../../lang-change';
import {TranslateService} from '@ngx-translate/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {UserConstants} from '../../../user/components/user-information/users-info';
import {Language} from '../../../../common/models/language';
import {CenterPositionService} from '../../../../common_services/dictionary-position.service';
import {Position} from '../../../admin/components/dictionary/position/dictionary-position';
import {DictionaryPositionType} from '../../../admin/components/dictionary/position/dictionary-position-type';
import {CenterCollege} from '../../../user/components/dictionary/university/center-college';
import {CenterCollegeService} from '../../../../common_services/center-college.service';
import {DictionaryService} from '../../../shared/services/dictionary.service';
import {UserApplication} from './user-application';
import {UserApplicationService} from '../../services/user-application.service';
import {CenterOrganizationService} from '../../../../common_services/center-organization.service';
import {CenterOrganization} from '../../../admin/components/dictionary/organization/center-organization';
import {Utils} from '../../../../common/services/Utils';

@Component({
  selector: 'app-user-application-dialog',
  templateUrl: './user-application-dialog.component.html',
  styleUrls: ['./user-application-dialog.component.scss']
})
export class UserApplicationDialogComponent extends LangChange implements OnInit {

  user: UserApplication = new UserApplication();
  positions: Position[] = [];
  positionTypes: DictionaryPositionType[] = [];
  userConst = UserConstants.userConst;
  universities: CenterCollege[] = [];
  organizations: CenterOrganization[] = [];
  sexes: any[] = [];
  public customPatterns = {'0': {pattern: new RegExp('[0-9-()\+ ]')}};
  profilePhotoUrl = 'assets/images/avatar.png';
  profilePhoto: any = null;
  documentList: any[] = [];
  confirmationDocumentList: any[] = [];

  constructor(public dialogRef: MatDialogRef<UserApplicationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _positionService: CenterPositionService,
              private _universityService: CenterCollegeService,
              private _organizationService: CenterOrganizationService,
              private _dictService: DictionaryService,
              private _utils: Utils,
              private _userApplicationService: UserApplicationService,
              private translateService: TranslateService) {
    super(translateService);
  }

  ngOnInit() {
    this.getDictionaries();
  }

  changePhoto(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e: any) => {
        this.profilePhotoUrl = e.target.result;
      };
      this.profilePhoto = file;
      event.target.value = '';
    }
  }

  deletePhoto() {
    this.profilePhoto = null;
    this.profilePhotoUrl = 'assets/images/avatar.png';
  }

  changeFileList(list, event) {
    const fileList: FileList[] = event.target.files;
    if (fileList && fileList.length) {
      list.push(...fileList);
      event.target.value = '';
    }
  }

  deleteFromList(list, item) {
    if (list) {
      const i = list.indexOf(item);
      if (i > -1) {
        list.splice(i, 1);
      }
    }
  }

  getDictionaries() {
    this._positionService.getTypes().subscribe(data => {
      this.positionTypes = data;
      Language.updateListLocalizedName(this.positionTypes);
    });
    this._universityService.getAll().subscribe(data => {
      this.universities = data;
      Language.updateListLocalizedName(this.universities);
    });
    this._organizationService.getAll().subscribe(data => {
      this.organizations = data;
      Language.updateListLocalizedName(this.organizations);
    });
    this._dictService.getSexList().subscribe(data => {
      this.sexes = data;
      Language.updateListLocalizedName(this.sexes);
    });
  }

  onSubmit(): void {
    const formData: FormData = new FormData();
    formData.append('applicationDTO', JSON.stringify(this.user));
    if (this.profilePhoto) {
      formData.append('photo', this.profilePhoto, this.profilePhoto['name']);
    }
    for (const i of Object.keys(this.documentList)) {
      formData.append('documentList', this.documentList[i], this.documentList[i]['name']);
    }
    for (const i of Object.keys(this.confirmationDocumentList)) {
      formData.append('files', this.confirmationDocumentList[i], this.confirmationDocumentList[i]['name']);
    }
    this._userApplicationService.save(formData).subscribe(
      response => {
        if (response.status === 'ERROR') {
          this.notifyInputError(response);
          return;
        }
        if (response.status === 'SUCCESS') {
          this._utils.notifySuccess(this._translateService.instant('user_application.sent'), null);
          this.close();
        }
      },
      error => {
        console.error(error);
        this._utils.notifyError(this._translateService.instant('error_occurred'), null);
        return;
      }
    );
  }

  notifyInputError(response: any): void {
    const errorList = response.additional;
    for (let i = 0; i < errorList.length; i++) {
      this._utils.notifyError(this._translateService.instant(errorList[i]), null);
    }
    if (response.data) {
      if (response.data.emailInputError === true) {
        this._utils.notifyError(this._translateService.instant('email_input_error'), null);
      }
      if (response.data.emailDuplicateError === true) {
        this._utils.notifyError(this._translateService.instant('email_duplicate_error'), null);
      }
      if (response.data.applicationEmailDuplicateError === true) {
        this._utils.notifyError(this._translateService.instant('application_email_duplicate_error'), null);
      }
    }
  }

  positionTypeChanged(): void {
    this.user.positionId = null;
    this.getPositions();
  }

  getPositions(): void {
    if (this.user.positionTypeId && this.user.positionTypeId > 0) {
      this._positionService.getByType(this.user.positionTypeId).subscribe(
        data => {
          this.positions = data;
          Language.updateListLocalizedName(this.positions);
        }
      );
    }
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close();
  }

  onLangChange(langCode): void {
    Language.updateListLocalizedName(this.positions);
    Language.updateListLocalizedName(this.sexes);
    Language.updateListLocalizedName(this.universities);
    Language.updateListLocalizedName(this.positionTypes);
    Language.updateListLocalizedName(this.organizations);
  }

  close(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/user-application-dialog/user-application-dialog.component.ts